import * as React from "react";
import { styled } from "styled-components";

const ImageContainer = styled.p`
  img {
    max-width: 100%;
  }
`;
const ImageLabel = styled.div`
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.colours.grey[400]};
  font-style: italic;
`;

export const Illustration: React.FC<{ src: string; label?: string }> = ({ src, label }) => {
  return (
    <ImageContainer>
      <img src={src} alt={label} aria-label={label} />
      <ImageLabel>{label}</ImageLabel>
    </ImageContainer>
  );
};
